const lang = {

    t: (term) => {

        const data = {
            ROLE_USER: 'Usuário',
            ROLE_ADMIN: 'Admin',
            corporateName: "Razão Social",
            cnpj: "CNPJ",
            cpf: "CPF",
            stateRegistration: "Inscrição Estadual",
            municipalRegistration: "Minicipio",
            primaryEmail: "email principal",
            primaryPhone: "telefone principal",
            primaryAddress: "Endereço Principal",
            primaryAddressNumber: "Número do endereço",
            primaryAdressDistrict: "Bairro do endereço principal",
            primaryAdressState: "UF do endereço principal",
            primaryAdressComplement: "Complemento",
            primaryPostalCode: "CEP Principal",
            secundaryEmail: "email secundário",
            secundaryPhone: "telefone secundário",
            secundaryAddress: "Endereço secundário",
            secundaryAddressNumber: "Número do endereço secundário",
            secundaryAdressDistrict: "bairro do endereço secundário",
            secundaryAdressState: "Estado do endereço secundário",
            secundaryAdressComplement: "Complemento do endereço secundário",
            secundaryPostalCode: "CEP secundário",
            legalRepresentativeName: "Nome do Representante Legal",
            legalRepresentativeCPF: "CPF do Representante Legal",
            legalRepresentativeCargo: "Cargo do Representante Legal",
            legalRepresentativePhone: "Telefone do Representante Legal",
            legalRepresentativeEmail: "Email do Representante Legal",
            tecnicalRepresentativeName: "Nome do Representante Tecnico",
            tecnicalRepresentativeCPF: "CPF do Representante Tecnico",
            tecnicalRepresentativeCargo: "Cargo do Representante Tecnico",
            tecnicalRepresentativePhone: "Telefone do Representante Tecnico",
            tecnicalRepresentativeEmail: "Email do Representante Tecnico"
        }

        return data[term] || term
    }
}

export default lang


// WEBPACK FOOTER //
// ./src/mixins/pt-br.js